export default "__VITE_ASSET__90b78a71__"